webpackJsonp([156897593687669],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PageHeader = __webpack_require__(56);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Page = __webpack_require__(54);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _PageBody = __webpack_require__(55);
	
	var _PageBody2 = _interopRequireDefault(_PageBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumePage = function ResumePage() {
	    return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_PageHeader2.default, { title: 'My resume' }),
	        _react2.default.createElement(
	            _PageBody2.default,
	            null,
	            _react2.default.createElement(
	                'div',
	                { id: 'main', className: 'site-main' },
	                _react2.default.createElement(
	                    'article',
	                    { className: 'page type-page status-publish hentry' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'entry-content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'vc_row wpb_row vc_row-fluid' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'wpb_column vc_column_container vc_col-sm-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'vc_column-inner ' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'wpb_wrapper' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'cms-about-wrap resume-education ' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'rounded-icon' },
	                                                _react2.default.createElement('i', { className: 'btn-icon fa fa-suitcase' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'resume-out' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'Software development team lead - ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: 'https://wwwdomain.com.au', target: '_blank' },
	                                                            'Domain'
	                                                        ),
	                                                        ', Melbourne'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        'May 2021 - Present'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'Senior front-end engineer - ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: 'https://wwwdomain.com.au', target: '_blank' },
	                                                            'Domain'
	                                                        ),
	                                                        ', Sydney'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        'January 2019 - May 2021'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'Front-end programmer - ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: 'https://clueylearning.com', target: '_blank' },
	                                                            'Cluey Learning'
	                                                        ),
	                                                        ', Sydney'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        'February 2018 \u2013 January 2019'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Introducing ReactJS and related technologies for front-end development'
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'Lead full stack developer - ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: 'https://bookmarc.io', target: '_blank' },
	                                                            'Bookmarc'
	                                                        ),
	                                                        ', Sydney'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        'August 2014 \u2013 December 2017'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'In charge of all technical aspects of development and maintenance of platform ',
	                                                            _react2.default.createElement(
	                                                                'a',
	                                                                { href: 'https://bookmarc.io', target: '_blank' },
	                                                                'bookmarc.io'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Leads a variable tem of in-house and remote back-end and front-end developers, including managing requirements, assessing results and mentoring.'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Implements a new version of the application built in Laravel 5.1.'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Progressive migration of front-end stack to ReactJS.'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Implementation of back-end ElasticSearch database.'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'In charge of system operations in Rackspace and AWS, including managing all the infrastructure in the cloud and related services.'
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'Web developer - ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: 'http://www.moovmedia.cl', target: '_blank' },
	                                                            'Moovmedia. Santiago, Chile'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        'September 2013 \u2013 August 2014'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Front-end and back-end development and maintenance of code in websites. '
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Development of e-commerce projects and Facebook apps.'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Use of Wordpress API, CodeIgniter, BackboneJS and server management.'
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'Web developer - ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: 'http://www.giga.cl', target: '_blank' },
	                                                            'GIGA. Santiago, Chile'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        'April 2013 \u2013 September 2013'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Website development and Facebook Contest Apps.'
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'Professor - ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: 'http://www.periodismo.uchile.cl/', target: '_blank' },
	                                                            'School of Journalism, University of Chile'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        'July 2009 \u2013 September 2012'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Professor in Diplomas \u201CDigital Journalism and internet media management\u201D, \u201CStrategic Communication and Leadership in Cultural Projects Management\u201D, \u201CCultural Journalism and Critics\u201D, \u201CInvestigative Journalism\u201D.'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Teacher in workshops \u201CUser Experience (UX) Design in web and other digital platforms\u201D and \u201CWebsite creation using WordPress\u201D'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Professor in courses \u201CMultimedia theory and practice\u201D and \u201CMultimedia Journalism Workshop\u201D. '
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'Web Developer \u2013 Project Manager - ',
	                                                        _react2.default.createElement(
	                                                            'a',
	                                                            { href: 'http://bibliotecas.uchile.cl/', target: '_blank' },
	                                                            'Library Systems - University of Chile'
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        'March 2008 \u2013 September 2010'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Part of the development team that renews university main website.'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'Project Manager in development of 6 faculty websites, using Oracle WebLogic CMS.'
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'li',
	                                                            null,
	                                                            'In charge of diverse innovation and improving processes in web development.'
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'vc_row wpb_row vc_row-fluid' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'wpb_column vc_column_container vc_col-sm-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'vc_column-inner ' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'wpb_wrapper' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'cms-about-wrap resume-education ' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'rounded-icon' },
	                                                _react2.default.createElement('i', { className: 'btn-icon fa fa-graduation-cap' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'resume-out' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'Proficient English'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        'April 2017 - IELTS'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        'Writing: 7.5 | Speaking: 7.5 | Reading: 9 | Listening: 9'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'Australian Skills Assessment: Developer Programmer'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        'April 2016'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        'Occupation: Developer Programmer (ANZCO CODE 261312)',
	                                                        _react2.default.createElement('br', null),
	                                                        'ICS skills assessment by Australian Computer Society'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'University of Chile'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        '2007'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        'Diploma in Digital Journalism and Internet Media Management | University of Chile'
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'resume-info' },
	                                                    _react2.default.createElement(
	                                                        'h2',
	                                                        { className: 'info-title' },
	                                                        'University of Chile'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: 'info-date' },
	                                                        '2007'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        'Journalist, Bachelor Degree in Social Communication'
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = ResumePage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resume-js-19d62cd4da40d91a337e.js